import React from 'react';
import PropTypes from 'prop-types';
import InfoCard from '../cards/info-card';

function StateDetails({
  setBuyerState, setValue, register, errors, buyerState, states,
}) {
  // console.log(buyerState, 'buyerState');
  return (
    <>
      <InfoCard
        title="State Of Residence"
        className=""
        subtitle="This will be used for GST purposes"
      />
      <div className=" grid gap-x-3 mb-1 sm:grid-cols-1 md:grid-cols-2">
        <div>
          <label htmlFor="state" className="block mb-2 text-[13px] md:text-[16px] font-medium">State*</label>
          <select
            id="state"
            value={buyerState}
            name="state"
            {...register('state')}
            disabled
            onChange={(e) => {
              setBuyerState(e.target.value);
            }}
            className="bg-white border border-[#B8E5FF] text-black text-[16px] md:text-[18px] rounded-lg focus:ring-black focus:border-[#B8E5FF] block w-full p-2.5"
          >
            <option value="">Select State</option>
            {states.map((st) => (
              <option key={st.stateCode} value={st.stateCode}>{st.name}</option>
            ))}
          </select>
          <p className="text-red-500 min-h-4 text-xs">{errors?.state?.message}</p>

        </div>
      </div>
    </>
  );
}
StateDetails.propTypes = {
  buyerState: PropTypes.string.isRequired,
  setBuyerState: PropTypes.func.isRequired,
  states: PropTypes.array,
  errors: PropTypes.object,
  setValue: PropTypes.func,
  register: PropTypes.func,
};
export default StateDetails;
